<template>
  <div class="md-layout text-center">
    <!-- Loader -->
    <div
      v-show="oAuthSigned === 2 || oAuthSigned === 0"
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <div class="loadingio-spinner-dual-ring-1dtfam0atym">
        <div class="ldio-739m8f7jx9t">
          <div></div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
      <div>
      <md-button
          slot="buttons"
          href="#facebook"
          @click="logout()"
          class="sidebar-normal"
      >
          {{this.$lang.menu.logout}}
      </md-button>
      </div>
     
    </div>

    <!-- Login form -->
    <div
      v-show="oAuthSigned === 3 || oAuthSigned === 4"
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="green">
        <h4 slot="title" class="title">{{$lang.general.log_in_via}}</h4>
        <!--         <md-button
          slot="buttons"
          href="#facebook"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-facebook-square"></i>
        </md-button>
        <md-button
          slot="buttons"
          href="#twitter"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-twitter"></i>
        </md-button>-->
        <md-button
          slot="buttons"
          href="#"
          class="md-just-icon md-simple md-white"
          @click="googleLogin"
          :disabled="oAuthSigned === 4"
        >
          <i class="fab fa-google"></i>
        </md-button>
        <p slot="description" class="description">
          -- {{$lang.general.or}} --
          <br />
          {{$lang.general.log_in_using_local_account}}
        </p>

        <md-field class="md-form-group md-has-value" :class="{ 'md-error': !userValid }" slot="inputs">
          <md-icon>account_circle</md-icon>
          <label>{{$lang.general.user}}</label>
          <md-input v-model="localUser" @click="userValid = true" type="text"></md-input>
        </md-field>

        <md-field class="md-form-group md-has-value" :class="{ 'md-error': !passwordValid }" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>{{$lang.general.password}}</label>
          <md-input v-model="localPassword" @click="passwordValid = true" type="password"></md-input>
        </md-field>

        <md-field class="md-form-group" slot="inputs">
          <md-icon>language</md-icon>
          <label>{{$lang.keys.language_select}}</label>
          <md-select v-model="langSelect">
            <md-option value="sk">{{$lang.general.slovak}}</md-option>
            <md-option value="en">{{$lang.general.english}}</md-option>
            <md-option value="de">{{$lang.general.deutsch}}</md-option>
          </md-select>
        </md-field>

        <md-button
          slot="footer"
          class="md-simple md-success md-lg"
          @click="localLogin"
        >{{$lang.keys.log_in}}</md-button>
      </login-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config/config";
import {
  setUserToken,
  getUserToken,
  getLastRoute
} from "@/storage/memoryStorage";
import { LoginCard } from "@/components";
import { sha256 } from "js-sha256";
import { handleRedirect } from "@/routes/routes";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      firstname: null,
      localUser: null,
      localPassword: null,
      userValid: true,
      passwordValid: true,
      auth2: null,
      langSelect: "",
      initializationAttempts: 0,
      oAuthSigned: 0
    };
  },

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    getLocation() {
      return this.$store.getters.getSettings.localization;
    }
  },

  watch: {
    langSelect: function(newLang, oldLang) {
      if (newLang !== oldLang) {
        this.changeLocation(newLang);
      }
    }
  },

  created() {
    this.googleAuthInitialization();
    this.langSelect = this.getLocation;

    window.addEventListener(
      "keyup",
      function(event) {
        if (event.keyCode === 13) {
          this.localLogin();
        }
      }.bind(this)
    );
  },

  methods: {
    pageRedirect() {
      const lastRoute = getLastRoute();

      if (lastRoute.route) {
        this.$router.push({ path: lastRoute.route });
      } else {
        this.$router.push({ path: handleRedirect() });
      }
    },

    logout() {
      window.gapi.load(
        "auth2",
        function() {
          window.gapi.auth2
            .init({
              client_id: config.API_KEYS.GOOGLE.OAUTH,
              scope: "profile email"
            })
            .then(
              function() {
                window.gapi.auth2.getAuthInstance().signOut();
                this.$store.commit("Logout");
              }.bind(this)
            );
        }.bind(this)
      );
    },

    changeLocation(location) {
      this.$lang.setLang(location);
      this.$store.commit("setLocation", location);
    },

    showErrorMessage(msg) {
      this.$notify({
        message: msg,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger",
        timeout: 5000
      });
    },

    googleAuthInitialization() {
      return new Promise((resolve, reject) => {
        try {
          this.initializationAttempts++;
          window.gapi.load(
            "auth2",
            function() {
              window.gapi.auth2.init({
                client_id: config.API_KEYS.GOOGLE.OAUTH,
                scope: "profile email"
              })
              .then((onInit, e) => {
                //console.log("Signed in?: ", onInit.isSignedIn.get());
                //const googleAuth = onInit.getAuthInstance();
                //onInit.isSignedIn.listen(this.signInProcess);
                
                if (onInit.isSignedIn.get()) {
                  this.oAuthSigned = 2;
                } else {
                  this.oAuthSigned = 3;
                }


                
              }).catch((error) => {
                if (error.error === "idpiframe_initialization_failed"){
                this.$notify({
                  message: this.$lang.messages.oauth_cookies_disabled,
                  horizontalAlign: "center",
                  verticalAlign: "bottom",
                  type: "danger",
                  timeout: 5000
                });
                }

                this.oAuthSigned = 4;
              });

              const googleAuth = window.gapi.auth2.getAuthInstance();
              googleAuth.isSignedIn.listen(this.signInProcess);

              resolve();
            }.bind(this)
          );
        } catch (err) {
          if (this.initializationAttempts < 5) {
            this.googleAuthInitialization();
          }
        }
      });
    },

    googleLogin: function() {
      // try {
      //     this.auth2.signIn({
      //       onsuccess: this.signInProcess
      //     });
      // } catch (err) {
      //   this.googleAuthInitialization().then(() => {
      //     this.auth2.signIn({
      //       onsuccess: this.signInProcess
      //     });
      //   });
      // }

      window.gapi.auth2.init({
        client_id: config.API_KEYS.GOOGLE.OAUTH,
        scope: "profile email"
      });

      const googleAuth = window.gapi.auth2.getAuthInstance();

      googleAuth.signIn({
        onsuccess: this.signInProcess
      });
    },

    signInProcess(isSignedIn) {
      if (isSignedIn) {
        this.oAuthSigned = 2;
        const authInstance = window.gapi.auth2
          .getAuthInstance()
          .currentUser.get();
        const access_token = authInstance.getAuthResponse(
          "includeAuthorizationData"
        ).access_token;

        const profile = authInstance.getBasicProfile();
        const tokenExpiration_ms = authInstance.getAuthResponse(
          "includeAuthorizationData"
        ).expires_at;

        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/auth/google",
          data: {
            token: access_token
          }
        })
          .then(response => {
            if (response.data.status === "OK") {
              this.$store.commit("setDeviceList", response.data.data);
              setUserToken(response.data.user.token);

              this.$store.commit("setAuth", {
                id: 2,
                type: "google",
                expiration: tokenExpiration_ms,
                user: profile.getEmail(),
                avatar: profile.getImageUrl(),
                user_name: profile.getName(),
                applications: response.data.user.applications,
                sections: response.data.user.sections
              });

              if (response.data.data.length > 0) {
                this.getHierarchyData();
              } else {
                this.showErrorMessage(this.$lang.messages.any_assigned_devices);
              }
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.code === 616) {
                this.showErrorMessage(
                  this.$lang.messages.login_credentials_incorrect
                );
              } else {
                this.showErrorMessage(
                  this.$lang.messages.api_communication_error
                );
              }
            } else {
              this.showErrorMessage(
                this.$lang.messages.api_communication_error
              );
            }
          });
      } else {
        this.oAuthSigned = 3;
        this.$store.commit("Logout");
        this.$router.push({ path: "/login" });
      }
    },

    localLogin() {
      if (this.localUser && this.localPassword) {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/auth/local",
          data: {
            login: this.localUser,
            password: sha256.hex(this.localPassword)
          }
        })
          .then(response => {
            if (response.data.status === "OK") {
              this.$store.commit("setDeviceList", response.data.data);
              setUserToken(response.data.user.token);

              this.$store.commit("setAuth", {
                id: 1,
                type: "local",
                expiration: new Date().getTime() + 3599000,
                user: this.localUser,
                applications: response.data.user.applications,
                sections: response.data.user.sections
              });

              if (response.data.data.length > 0) {
                this.getHierarchyData();
              } else {
                this.showErrorMessage(this.$lang.messages.any_assigned_devices);
              }
            } else {
              this.showErrorMessage("Sig in process error.");
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.code === 603) {
                this.showErrorMessage(
                  this.$lang.messages.login_credentials_incorrect
                );
              } else {
                this.showErrorMessage(
                  this.$lang.messages.api_communication_error
                );
              }
            } else {
              this.showErrorMessage(
                this.$lang.messages.api_communication_error
              );
            }
            this.userValid = false;
            this.passwordValid = false;
          });
      } else {
        this.userValid = this.localUser ? true : false;
        this.passwordValid = this.localPassword ? true : false;
      }
    },

    async getHierarchyData() {
      return axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/facility/devices-hierarchy",
        data: {
          token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            //this.$store.commit("setHierarchy", response.data.data);

            //DEFAULT DEVICE
            if (
              !this.selectedDevice ||
              this.deviceList.findIndex(
                e => e.mac == this.selectedDevice.mac
              ) == -1
            ) {
              const defIndex = response.data.data.tags.findIndex(
                e => e.mac && e.title
              );

              this.$store.commit("setSelectedDevice", {
                title: response.data.data.tags[defIndex].title,
                mac: response.data.data.tags[defIndex].mac
              });
            } else {
              const indexInResponse = response.data.data.tags.findIndex(
                e => e.mac == this.selectedDevice.mac
              );

              if (
                response.data.data.tags[indexInResponse].title !==
                this.selectedDevice.title
              ) {
                this.$store.commit("setSelectedDevice", {
                  title: response.data.data.tags[indexInResponse].title,
                  mac: response.data.data.tags[indexInResponse].mac
                });
              }
            }
            this.pageRedirect();
          }
        })
        .catch(error => {
          //DEFAULT DEVICE
          if (
            !this.selectedDevice ||
            this.deviceList.findIndex(
              e =>
                e.mac == this.selectedDevice.mac &&
                e.mac == this.selectedDevice.title
            ) == -1
          ) {
            this.$store.commit("setSelectedDevice", {
              title: this.deviceList[0].mac,
              mac: this.deviceList[0].mac
            });
          }

          if (error.hasOwnProperty("response")) {
            if (error.response.data.status == "FAIL") {
              if (error.response.data.code !== 610) {
                this.showErrorMessage(
                  this.$lang.messages.api_communication_error
                );
              }
            }
          }
          this.pageRedirect();
        });
    }
  },

  beforeDestroy() {
    this.localUser = null;
    this.localPassword = null;
  }
};
</script>

<style>
.md-select-value {
  margin-left: 12px;
}
</style>

<style type="text/css">
@keyframes ldio-739m8f7jx9t {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ldio-739m8f7jx9t div {
  box-sizing: border-box !important;
}
.ldio-739m8f7jx9t > div {
  position: absolute;
  width: 72px;
  height: 72px;
  top: 14px;
  left: 14px;
  border-radius: 50%;
  border: 8px solid #000;
  border-color: #fff9f5 transparent #fff9f5 transparent;
  animation: ldio-739m8f7jx9t 1s linear infinite;
}
.ldio-739m8f7jx9t > div:nth-child(2) {
  border-color: transparent;
}
.ldio-739m8f7jx9t > div:nth-child(2) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.ldio-739m8f7jx9t > div:nth-child(2) div:before,
.ldio-739m8f7jx9t > div:nth-child(2) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  top: -8px;
  left: 24px;
  background: #fff9f5;
  border-radius: 50%;
  box-shadow: 0 64px 0 0 #fff9f5;
}
.ldio-739m8f7jx9t > div:nth-child(2) div:after {
  left: -8px;
  top: 24px;
  box-shadow: 64px 0 0 0 #fff9f5;
}
.loadingio-spinner-dual-ring-1dtfam0atym {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-739m8f7jx9t {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-739m8f7jx9t div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>
